/* global fetch $ Image */
import $ from "jquery";
import { setScrollBottom, createAddDislike, getMetaValue } from "./dialog_general.js";
import { checkNested, getConfig, urlParseCheck, createGuid } from "../general_functions.js";
import { getAimData } from "./dialog_aim.js";
import { search } from "./dialog_search.js";
import dayjs from "dayjs";
import setAccordian from "../accordian.js";
import language from "../translation";
import kariavatar from "../kariavatar";
import { getMetadataValue } from "../search";

window.messagesToShow = [];

function switchSearchLinks(val) {
    let res = "";

    // console.log("val", val)

    if (checkNested(val, "payload", "index", "items", "results")) {
        res += `<div class="dialog__fromkari__actionlinks dialog__searchresults">`;
        $.each(val.payload.index.items.results, function(a, b) {

            // 
            // let id = b.id.split("Content/")[1];

            let id = getMetadataValue(b, "ContentId");

            let pagetype = getMetaValue(b.metadata, "PageTypeId");

            // b.metaParsed = {}
            // if(b.metadata){
            //     b.metadata.forEach(item => {
            //         b.metaParsed[item.name] = item.value;
            //     })
            // }

            // // console.log(b);

            // let template = "artikkel";
            // if(checkNested(b,"metaParsed","PageTypeId")){
            //     template = b.metaParsed.PageTypeId.replace("mal_","").replace("smal","");
            // }

            if (pagetype.length > 0) {
                // pagetype = pagetype.replace("mal_","").replace("smal","")
            }


            let url = "/artikkel/" + id;


            res += `<a href="${url}" 
                        data-id="${id}" 
                        class="dialog__fromkari__link normal dialog__fromkari__${pagetype}">${b.title}</a>`;

        });
        res += `</div>`;

    }
    else {
        console.error("error start test");
    }
    return res;
}


function switchLinks(val) {
    let res = "";
    res += `<div class="dialog__fromkari__actionlinks">`;
    const siteConfig = getConfig();

    const url_guid = /^(.*:)(\{{0,1}([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}\}{0,1})$/gi;
    const countlinks = val.payload.links.length;
    $.each(val.payload.links, function(a, b) {
        if (b.type == "action_link") {
            let phrase = $.trim($(".dialog__fromuser").last().text());
            if (b.text === "Søk på nettside") {
                res += `<a href="search/${phrase}?sok=${phrase}" class="dialog__fromkari__link dialog__fromkari__link--search">${b.text}</a>`;
            }
            else {
                res += `<button data-type="${b.type}" data-id="${b.id}" class=" dialog__fromkari__link">${b.text}</button>`;
            }
            if (b.text === "Snakk med min kollega?") {
                res += `<a href="search/${phrase}?sok=${phrase}" class="dialog__fromkari__link dialog__fromkari__link--search">Søk på nettsiden</a>`;
            }
        }
        else {

            // console.log("b, id", b, id, (id === "7635218") );

            let url = b.url,
                target = b.link_target,
                search = false,
                download = b.url.match(/[pdf|doc|docx|xls|xlsx|odt|ppt|pptx|txt|ods]{3,4}$/gi) ? "download" : "",
                domain = url.split(/^(.*:)\/\/([A-Za-z0-9\-\.]+)(:[0-9]+)?(.*)$/gi)[2],
                id = b.id

            target = "normal";

            if (url.match(/aim:skjema:||skjema:/gi)) {

                target = "dialog__fromkari__mal_skjema";
                url = urlParseCheck(url);
                id = b.url.replace("aim:", "").replace("skjema:", "");

            }
            else if (url.match(/aim:/gmi)) {

                target = "dialog__fromkari__mal_blokk";
                url = urlParseCheck(url);
                id = b.url.replace("aim:", "").replace("skjema:", "");

            }
            if (url.match(url_guid) && countlinks === 1) {
                messagefromSystem("Fra nettsiden:");
                getAimData(url.split(":")[1]);
            }
            else {

                // console.log("url", window.location.host );

                // console.log("target", target, b);

                if (!url.match(/\.aim|\.kommune/gi)) {
                    target = "_blank";
                }

                if (url.match(/^\//gmi)) {
                    target = "normal";
                }

                res += `<a href="${url}" 
                                    data-id="${id}" 
                                    ${(search  ? `data-search="${search}"` : "")} 
                                    ${(target === "_blank" ? `target="_blank"` : "")} 
                                    class="dialog__fromkari__link ${target} ${download}">${b.text}</a>`;
            }

        }
    });
    res += `</div>`;

    return res;
}

function removeWords(str) {
    let stripThese = ["hvem", "hva", "hvor", "hvorfor", "hvordan", "Søk",
        // "#", "@", "(", ")", "[", "]", "/", "\\", "\"", "'", "»", "«", // keeping %
        "fordi", "så", "at", "dersom", "hvis", "som", "når", "da", //Subjunksjon
        "på", "under", "over", "gjennom", "mellom", "bak", "inni", //Preposisjon
        "og", "eller", "men", "for", // Konjunksjoner
        "meg", "deg", "ham", "han", "henne", "den", "det", "jeg", "eg", "du", "han", "hun", "ho", "den", "det", "vi", "me", "dere", "de", "dei", "oss", "dere", "dem", "dei", // pronomen
        "er", "har", "ny", "gammel", "passe" //verb
    ]
    let puncts = ["\\?", "\\!", "\\.", "\\,"];
    let regex = new RegExp("\\b" + stripThese.join('\\b|\\b') + "\\b|" + puncts.join("|"), "gi")
    // console.log("regex", "\\b" + stripThese.join('\\b|\\b') + "\\b|" + puncts.join("|"));
    return str.replace(regex, '')
}

export const initBotInstance = () => {

    if (!sessionStorage.getItem("chat_sessionid") || sessionStorage.getItem("chat_sessionid") === "") {

        let filter = [];
        filter.push(client.nameId)
        if (client.lang === "nn") {
            filter.push("Nynorsk")
        }

        fetch("//007prokom.boost.ai/api/chat/v2", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                "command": "START",
                //"filter_values": [sessionStorage.getItem("kommune")],
                "filter_values": filter
            })
        }).then(res => {
            res.json().then(data => {

                sessionStorage.setItem("chat_sessionid", data.conversation.id);
                sessionStorage.setItem("chat_initialresponse", JSON.stringify(data.response.elements));
                sessionStorage.setItem("conversationHtml", "");

                let msgnr = 0;
                $.each(data.response.elements, function(a, b) {
                    let msgNrClass = (msgnr === 0) ? "dialog__start first" : "dialog__start";
                    messagefromSystem(b.payload.html, b.payload.type, true, msgNrClass);
                    // setScrollBottom();
                    msgnr++;
                });

                setTimeout(function() {
                    if ($(".dialog__fromkari.dialog__start").length < 1) {
                        // messagefromSystem(language("INTRO_QUESTION"), "html", true, "dialog__start");
                    }
                }, 1000);

            });
        });
    }
    WriteFromMessageQueue(true);
};

export const messageEllipse = (state = "start") => {
    if (state === "stop") {
        $(".removewhendone").remove();
    }
    else {
        setTimeout(function() {
            $("#kari__dialog__window").append(messagefromBot());
            setScrollBottom();
        }, 200);
    }
};

export const messagefromSystem = (val = "test", type = "html", skipsave, msg_class) => {

    // CHANGECONV $("#kari__dialog__window").append(messagefromBot({
    //     "type": type,
    //     "payload": {
    //         "html": val

    //     }
    // }, skipsave, msg_class));

    messagequeue.push(messagefromBot({
        "type": type,
        "payload": {
            "html": val

        }
    }, skipsave, msg_class))

    if (typeof kariAnimator !== "undefined") {
        kariAnimator.animateHair(2);
    }
};

export const messagefromBot = (val, skipbuild, msg_class = "") => {
    let sval = JSON.parse(sessionStorage.getItem("conversation")) || false;
    let obj = { from: "kari", message: val };

    const siteConfig = getConfig();

    // window.queue = [];

    if (!sval) {
        sval = [obj];
    }
    else {
        sval.push(obj);
    }

    if (!skipbuild) {
        sessionStorage.setItem("conversation", JSON.stringify(sval));
    }


    let res = "";

    if (typeof val === "undefined") {
        return `
                <div class="dialog__message__container removewhendone">
                    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                </div>`;
    }

    let kari = "";

    if (msg_class.match("first")) {
        kari = kariavatar();
    }

    switch (val.type) {

        case "html":
            res = `<div class='dialog__fromkari ${msg_class}'><div class="dialog__avatarcontainer repeat">${kari}</div>${val.payload.html}</div>`;

            break;
        case "image":
            let img = new Image();
            img.onload = function() { setScrollBottom(); };
            img.src = val.payload.url;
            res = `<div class='dialog__fromkari__imagecontainer  ${msg_class}'>
                        <img src="${val.payload.url}" alt="${val.payload.alt_text}" class="dialog__fromkari__image">
                    </div>`;
            break;
        case "vote":
            res = val.html;
            break;
        case "seperator":
            res = `<div class="dialog__seperator"><span class="dialog__seperator__text">${language("NEW_CONVERSATION")}</span></div>`;
            break;
        case "links":
            console.log("links")
            res = switchLinks(val);
            break;
        case "searchlinks":
            console.log("switchSearchLinks")
            res += switchSearchLinks(val)
            break;

    }

    // let ans = ["","Minecraft", "Du suger", "f. deg"];



    //     res = ans[Math.floor(Math.random() * 3) + 1  ];
    const returnHtml = `
            <div class="dialog__message__container">
                ${res}
            </div>
        `;

    if (!skipbuild) {
        sessionStorage.setItem("conversationHtml", sessionStorage.getItem("conversationHtml") + returnHtml);
    }
    return returnHtml;
  
};

export const messagefromUser = (val, skipbuild) => {

    val = val.replace(/([0-9][[:blank:]]?){6,12}/gi, " ****(kryptert)");

    sessionStorage.setItem("lastmessage", dayjs().valueOf());


    let sval = JSON.parse(sessionStorage.getItem("conversation")) || false;
    let obj = { from: "user", message: val };

    if (!sval) {
        sval = [obj];
    }
    else {
        sval.push(obj);
    }

    if (!skipbuild) {
        sessionStorage.setItem("conversation", JSON.stringify(sval));
    }

    const returnHtml = `
            <div class="dialog__message__container text-right">
                <div class='dialog__fromuser'>
                ${val}
                </div>
            </div>
        `;


    if (!skipbuild) {
        sessionStorage.setItem("conversationHtml", sessionStorage.getItem("conversationHtml") + returnHtml);
    }
    return returnHtml;
};

export const messageJsonMap = (obj) => {

    // console.log("search nu")

    if (checkNested(obj, "aim404")) {

        const guid = /^(\{{0,1}([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}\}{0,1})$/gi;

        let msg = $.trim($(".dialog__fromuser").last().text());

        if (msg.match(guid)) {

            getAimData(msg);

        }
        else { // IF NOT Guid
            search(msg);
        }
        return false;
    }
    if (checkNested(obj, "aimContent")) {
        getAimData(obj.aimContent);
    }
    if (checkNested(obj, "trigger")) {
        if (obj.trigger === "bookup") {

        }
    }

};

export const checkTemplateTypeSearch = (metadata) => {


    // console.log("metadata", metadata);

    let result = metadata.filter(obj => {

        return obj["name"] === "PageTypeId" // fjernet urlify

    });

    return result[0];


}

export const WriteFromMessageQueue = () => { // kari__dialog__window


    let reply = messagequeue[0];

    let time = 1000;
    if (typeof messagequeue[0] === "string") {
        if (messagequeue[0]) {
            if (messagequeue[0].length < 10) {
                time = 0;
            }
            else if (messagequeue[0].length < 30) {
                time = 600;
            }
            else if (messagequeue[0].length > 60) {
                time = 1800;
            }
            messageEllipse();
        }
    }

    time = time;


    setTimeout(() => {

        messageEllipse("stop");

        if (messagequeue.length > 0) {

            // console.log("reply", reply, time, messagequeue.length, messagequeue);

            if (typeof messagequeue[0] === "string") {
                $("#kari__dialog__window").append(messagequeue[0]);
                setScrollBottom();

                messagequeue.shift();
            }
            else if (typeof messagequeue[0] === "object") {
                const obj = messagequeue[0];
                if (obj.type === "feedback" && obj.data) {
                    createAddDislike(obj.data);
                    messagequeue.shift();
                }
            }
            else {
                console.log("neither");
            }
        }
        WriteFromMessageQueue();

    }, time);
}

export const messagePostBot = (val) => {

    $("#kari__dialog__window").append(messagefromUser(val));
    setScrollBottom();

    // Load loader
    messageEllipse();

    const guid = /^(\{{0,1}([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}\}{0,1})$/gi;

    let msg = $.trim($(".dialog__fromuser").last().text());

    if (msg.match(guid)) {



        getAimData(msg);



    }
    else {

        let body = {
            "command": "POST",
            "type": "text",
            "value": val,
        }

        let filter = [];

        filter.push(client.nameId)

        if (client.lang === "nn") {
            filter.push("Nynorsk")
        }

        body.filter_values = filter;

        if (sessionStorage.getItem("chat_sessionid") && sessionStorage.getItem("chat_sessionid").length > 0) {
            body.conversation_id = sessionStorage.getItem("chat_sessionid")
        }


        fetch("//007prokom.boost.ai/api/chat/v2", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body)
        }).then(res => {

            res.json().then(data => {

                // let passlast;
                let msgnr = 0;

                $(".removewhendone").remove();

                let json = false;

                $.each(data.response.elements, function(a, b) {

                    let msgNrClass = "";

                    if (msgnr === 0) {
                        msgNrClass = "first";
                    }

                    if (checkNested(b, "payload", "json")) {


                        let kariJsonReturn = messageJsonMap(b.payload.json);
                        if (kariJsonReturn === false)
                            return;
                    }
                    else {

                        // window.messagesToShow.push({id: createGuid(), html : messagefromBot(b, false, msgNrClass)})
                        // CHANGECONV $("#kari__dialog__window").append(messagefromBot(b, false, msgNrClass));
                        messagequeue.push(messagefromBot(b, false, msgNrClass));

                    }
                    setScrollBottom();

                    msgnr++;

                });

                // console.log("adding feedback")
                messagequeue.push({ type: "feedback", data: data })


                //  metadata: [
                //      { name: "Title", value: "${val}" }
                //   ]


                let q = removeWords(val.toLowerCase());


                let query = `query {      
                            index {
                                items (
                                    filter: {
                                        searchQuery: "${q}",       
                                        skip: 0,
                                        take: 20,
                                        queryType: MATCHANY,
                                        sortBy: RELEVANCE,
                                        categories: [
                                           { values: ["contentSubscribers", "${client.clientId}"] }
                                        ]
                                    }                 
                                )    
                                {
                                    hits,results {
                                        title, date, content, id, url, relevance, extracts, 
                                        metadata {
                                            name, value
                                        },
                                        categories {
                                            values
                                        }
                                    }
                                }
                            } 
                        }`;

                $.ajax({
                    type: "POST",
                    headers: {
                        "ApiKey": 'f28f2f36-d7d7-4b23-a2d3-1d8ec34c4b45',
                        "Content-Type": "application/graphql"
                    },
                    url: searchEngine,
                    data: query,
                    success: function(data) {
                        if (checkNested(data.data, "index", "items", "results", "0")) {
                            let result = data.data.index.items.results;
                            if (result.length > 0 && result[0].relevance > 1000) {

                                let tempType = checkTemplateTypeSearch(result[0].metadata);

                                // console.log("tempType", tempType);

                                if (tempType.value === "mal_blokk") {
                                    messagefromSystem(language("I_ALSO_FOUND_THIS"));
                                }
                                // else if(tempType.value === "mal_blokk"){
                                //     messagefromSystem("Jeg fant også denne infoen fra nettsiden:");
                                // }
                                else {
                                    messagefromSystem(language("I_ALSO_FOUND_THIS"));
                                }

                                let newOb = {
                                    data: {
                                        index: {
                                            items: {
                                                results: [result[0]]
                                            }
                                        }
                                    }
                                };

                                // window.messagesToShow.push({id: createGuid(), html : messagefromBot({ type: "searchlinks", payload: newOb.data })})
                                // CHANGECONV $("#kari__dialog__window").append(messagefromBot({ type: "searchlinks", payload: newOb.data }));
                                messagequeue.push(messagefromBot({ type: "searchlinks", payload: newOb.data }, false, "bot__searchresult"))
                            }
                            else if (result.length > 1) {
                                // console.log("more than 1");
                            }
                            else {
                                // console.log("less than 1");
                            }
                        }
                        else {

                            // console.log("Check nested false", data);
                        }
                    }
                });


            });
        });

    }


};

export const clickVote = (id, value) => {

    let body = {

        "command": "POST",
        "type": "feedback",
        "id": id,
        "value": value

    }

    if (sessionStorage.getItem("chat_sessionid") && sessionStorage.getItem("chat_sessionid").length > 0) {
        body.conversation_id = sessionStorage.getItem("chat_sessionid")
    }

    fetch("//007prokom.boost.ai/api/chat/v2", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
    }).then(res => {


    });
};

export const clickButtonAction = (id) => {

    let body = {

        "command": "POST",
        "type": "action_link",
        "id": id

    }


    if (sessionStorage.getItem("chat_sessionid") && sessionStorage.getItem("chat_sessionid").length > 0) {
        body.conversation_id = sessionStorage.getItem("chat_sessionid")
    }


    fetch("//007prokom.boost.ai/api/chat/v2", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({

            "command": "POST",
            "type": "action_link",
            "conversation_id": sessionStorage.getItem("chat_sessionid"),
            "id": id

        })
    }).then(res => {

        res.json().then(data => {

            $.each(data.response.elements, function(a, b) {

                // CHANGECONV $("#kari__dialog__window").append(messagefromBot(b));
                messagequeue.push(messagefromBot(b))

                setScrollBottom();


            });

        });
    });
};
